import { z } from 'zod/v4';
import { CreatedQuestionnaireSchema } from './questionnaire-create.js';

export const GetQuestionnaireParamsSchema = z.object({
  id: z.string().min(1),
});

export type GetQuestionnaireParams = z.infer<
  typeof GetQuestionnaireParamsSchema
>;

/**
 * `GET /api/questionnaires/:id` — the questionnaire row plus its sub-resources.
 *
 * Built on `CreatedQuestionnaireSchema` because both responses come from the
 * same `getQuestionnaireByIdDb` projection.
 *
 * `questions` and `sections` are always empty. The legacy handler spread
 * `{ ...questionnaire, questions: [], sections: [] }` behind a "to-do after
 * tables created" comment and nothing has wired them up since. They stay in the
 * contract so consumers keep the fields, and stay untyped so populating them
 * has to come with a deliberate schema change.
 */
export const QuestionnaireDetailSchema = CreatedQuestionnaireSchema.extend({
  questions: z.array(z.unknown()),
  sections: z.array(z.unknown()),
});

export type QuestionnaireDetail = z.infer<typeof QuestionnaireDetailSchema>;
